import {
  Message
} from 'element-ui'
import {
  errorCode
} from '@/config'

const colorData = {
  "0": "#79ACFF",
  "1": "#B7A1FF",
  "2": "#90DF89",
  "3": "#FFD666",
  "4": "#A7B2D2",
  "5": "#69DAD8",
  "6": "#79ACFF",
  "7": "#B7A1FF",
  "8": "#90DF89",
  "9": "#A7B2D2",
}

export function formatTime(second) {
  let m = Math.floor(second / 60)
  let s = second - m * 60
  m = m < 10 ? '0' + m : m + ''
  s = s < 10 ? '0' + s : s + ''
  return m + ':' + s
}

export const optionalChaining = (obj, ...keys) => {
  return keys.reduce((acc, key) => acc?.[key], obj);
};

export function htmlEncodeByRegExp(str) {
  let s = "";
  if (str.length == 0) return "";
  s = str.replace(/&/g, "&amp;");
  s = s.replace(/</g, "&lt;");
  s = s.replace(/>/g, "&gt;");
  s = s.replace(/ /g, "&nbsp;");
  s = s.replace(/\'/g, "&#39;");
  s = s.replace(/\"/g, "&quot;");
  return s;
}

/**
 * 处理数学表达式（分数、指数、填空等）
 * @param {string} text - 要处理的文本
 * @returns {string} 处理后的文本
 */
export function processMathExpressions(text = '') {
  let repNum = 0;

  // 提取处理填空标记的辅助函数
  const processFillMarks = (text, isFraction = false) => {
    return text.replace(/___\d+___/g, () => {
      repNum++;
      const className = isFraction ? 'fill-mark-fraction' : 'fill-mark';
      const content = isFraction ? repNum : `<em>___</em><i>${repNum}</i>`;
      return `<span class="${className}">${content}</span>`;
    });
  };

  // 提取处理分数表达式的函数
  const processFraction = (numerator, denominator) => {
    const numProcessed = processFillMarks(numerator, true);
    const denProcessed = processFillMarks(denominator, true);
    return `<div class="fraction-ui"><span class="numerator">${numProcessed}</span><span class="fraction-line"></span><span class="denominator">${denProcessed}</span></div>`;
  };

  // 提取处理指数表达式的函数
  const processExponent = (base, exponent) => {
    const baseProcessed = processFillMarks(base, false);
    const exponentProcessed = processFillMarks(exponent, false);
    return `<div class="exponent-ui"><span class="base">${baseProcessed}</span><span class="exponent">${exponentProcessed}</span></div>`;
  };

  // 提取处理独立填空项的函数
  const processStandaloneFill = () => {
    repNum++;
    return '<span class="fill-mark"><em>______</em><i>' + repNum + '</i></span>';
  };

  // 用于检查是否包含 ___数字___ 格式的正则表达式
  const numPattern = /___\d+___/;

  return (text || '').replace(/(___\d+___)|(##\$\$##)|(______)|\\\(\\frac\{([^\}]*)\}\{([^\}]*)\}\\\)|\\\(\{?([^{}^]*)\}?\^\{?([^{}^]*)\}?\\\)/g, (match, blank1, blank2, blank3, num, den, base, exponent) => {
    // 如果是分数表达式
    if (num !== undefined && den !== undefined &&
      (numPattern.test(num) || numPattern.test(den))
    ) {
      return processFraction(num, den);
    }

    // 如果是指数表达式
    if (base !== undefined && exponent !== undefined &&
      (numPattern.test(base) || numPattern.test(exponent))
    ) {
      return processExponent(base, exponent);
    }
    
    // 如果是独立填空项
    if (blank1 !== undefined || blank2 !== undefined || blank3 !== undefined) {
      return processStandaloneFill();
    }
    
    return match;
  });

}

export function htmlDecodeByRegExp(str, type) {
  let s = '',
    repNum = 0;
  if (str) {
    if (str.length === 0) return '';
    str = str + '';
    s = str.replace(/&amp;/g, '&');
    s = s.replace(/&lt;/g, ' <');
    s = s.replace(/&gt;/g, '> ');
    s = s.replace(/&nbsp;/g, ' ');
    s = s.replace(/<br\/>/g, '');
    s = s.replace(/<stong\/>/g, '');
    s = s.replace(/&#39;/g, "'");
    s = s.replace(/&quot;/g, '"');
    s = s.replace(/\$/g, ' $ ');
    s = s.replace(/【high(\d)*?】/g, '');
    s = s.replace(/【\/high(\d)*?】/g, '');
    s = s.replace(/【下划线】/g, '<u>', s);
    s = s.replace(/【\/下划线】/g, '</u>', s);
    s = s.replace(/【【题干】/g, '', s);
    s = s.replace(/\/题干】/g, '', s);
    s = s.replace(/<font[^>]*>/gi, '').replace(/<\/font>/gi, '');

    // type = 1  不可编辑
    s = s.replace(/___\d___/g, (s, i) => {
      repNum++;
      return (
        '<span id="answer_' + repNum + '" class="imitate_input">___'+repNum+'___</span>'
      );
    });
    s = s.replace(/\#\#\$\$\#\#/g, (s, i) => {
      repNum++;
      return (
        '<span id="answer_' + repNum + '" class="imitate_input">______</span>'
      );
    });
    
  }
  return s;
}

/**
 * 将字符串中的百分号（%）替换为转义后的百分号（\%）。
 * @param {string} str - 需要处理的字符串。
 * @returns {string} 处理后的字符串，其中百分号被转义。
 */
export function replacePercentWithEscapedPercent(str) {
    let result = '';
    let escaped = false;
    for (let i = 0; i < str.length; i++) {
        if (str[i] === '\\') {
            escaped = !escaped;
            result += str[i];
        } else if (str[i] === '%' && !escaped) {
            result += '\\%';
            escaped = false;
        } else {
            result += str[i];
            escaped = false;
        }
    }
    return result;
}

// 统一处理有Latex答案
export function decodeForAnswer (str = '', subjectId) {
  let decodeStr = ''
  if (subjectId == 1 || subjectId == 3) {
    decodeStr = htmlDecodeByRegExp(str)
  } else {
    str = str + '';
    str = str.replace(/</g, '&amp;lt;')
    str = replacePercentWithEscapedPercent(str)
    decodeStr = scienceHtmlDecodeByRegExp(str)
  }
  return decodeStr.replace(/<[^<>]+>/g, '')
}

export function scienceHtmlDecodeByRegExp(str) {
  let s = '',
    repNum = 0;
  if (str) {
    if (str.length === 0) return '';
    str = str + '';
    s = str.replace(/&amp;/g, '&');
    s = s.replace(/&lt;/g, ' < ');
    s = s.replace(/&gt;/g, ' > ');
    s = s.replace(/&nbsp;/g, ' ');
    s = s.replace(/<br\/>/g, '');
    s = s.replace(/<stong\/>/g, '');
    s = s.replace(/&#39;/g, "'");
    s = s.replace(/&quot;/g, '"');
    s = s.replace(/\$/g, ' $ ');
    s = s.replace(/\\\\/g, '\\\\ ');
    s = s.replace(/\overrightarrow/g, 'overrightarrow ');
    
    // type = 1  不可编辑
    // s = s.replace(/___\d___/g, (s, i) => {
    //   repNum++;
    //   return (
    //     '<span id="answer_' + repNum + '" class="imitate_input">______</span>'
    //   );
    // });
    // s = s.replace(/\#\# \$  \$ \#\#/g, (s, i) => {
    //   repNum++;
    //   return (
    //     '<span id="answer_' + repNum + '" class="imitate_input">______</span>'
    //   );
    // });

    // 使用提取的函数处理数学表达式
    s = processMathExpressions(s);
  }
  return s;
}

export function arrSortToString(arr, sort = false) {
  let str = ''
  if (!sort) {
    arr.forEach(item => {
      if (typeof item === 'object') {
        str += arrSortToString(item, true)
      } else {
        str += item.toString()
      }
    })
  } else {
    arr.sort().forEach(item => {
      if (typeof item === 'object') {
        str += arrSortToString(item, true)
      } else {
        str += item.toString()
      }
    })
  }

  return str
}
export function answerFormat(arr) {
  let str = ''
  arr.slice().forEach(item => {
    str += item[0].content + ';'
  })
  return str.slice(0, -1)
}

export function getQueryString(name) {
  var search = window.location.href.split('?')[1]
  if (search) {
    var params = search.split('&')
    var obj = {}

    for (var i = 0, l = params.length; i < l; i++) {
      var tmp = params[i].split('=')
      obj[tmp[0]] = tmp[1]
    }

    return obj[name] || "";
  }
  return ""
}

export function rem(win) {
  function resize() {
    var domWidth = domEle.getBoundingClientRect().width;
    if (domWidth / v > 540) {
      domWidth = 540 * v;
    }
    win.rem = domWidth / 16;
    domEle.style.fontSize = win.rem + "px";
  }
  var v, initial_scale, timeCode, dom = win.document,
    domEle = dom.documentElement,
    viewport = dom.querySelector('meta[name="viewport"]'),
    flexible = dom.querySelector('meta[name="flexible"]');
  if (viewport) {
    var o = viewport.getAttribute("content").match(/initial\-scale=(["']?)([\d\.]+)\1?/);
    if (o) {
      initial_scale = parseFloat(o[2]);
      v = parseInt(1 / initial_scale);
    }
  } else if (flexible) {
    var o = flexible.getAttribute("content").match(/initial\-dpr=(["']?)([\d\.]+)\1?/);
    if (o) {
      v = parseFloat(o[2]);
      initial_scale = parseFloat((1 / v).toFixed(2))
    }
  }
  if (!v && !initial_scale) {
    var n = (win.navigator.appVersion.match(/android/gi), win.navigator.appVersion.match(/iphone/gi));
    v = win.devicePixelRatio;
    v = n ? v >= 3 ? 3 : v >= 2 ? 2 : 1 : 1, initial_scale = 1 / v
  }
  //没有viewport标签的情况下
  if (domEle.setAttribute("data-dpr", v), !viewport) {
    if (viewport = dom.createElement("meta"), viewport.setAttribute("name", "viewport"), viewport.setAttribute("content", "initial-scale=" + initial_scale + ", maximum-scale=" + initial_scale + ", minimum-scale=" + initial_scale + ", user-scalable=no"), domEle.firstElementChild) {
      domEle.firstElementChild.appendChild(viewport)
    } else {
      var m = dom.createElement("div");
      m.appendChild(viewport), dom.write(m.innerHTML)
    }
  }
  win.dpr = v;
  win.addEventListener("resize", function () {
    clearTimeout(timeCode), timeCode = setTimeout(resize, 300)
  }, false);
  win.addEventListener("pageshow", function (b) {
    b.persisted && (clearTimeout(timeCode), timeCode = setTimeout(resize, 300))
  }, false);
  resize();
}

export function isArray(obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object array]') {
    return true
  }
  return false
}

export function isObject(obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object object]') {
    return true
  }
  return false
}

export function isString(obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object string]') {
    return true
  }
  return false
}

export function showErrMessage(e, msg) {
  let m = ''

  if (isObject(e)) {
    m = errorCode[e.code] ? e.msg : '网络错误'
  } else {
    m = msg
  }

  if(typeof m != 'undefined'){
    Message({
      message: m,
      type: 'error',
      duration: 3 * 1000
    })
  }
  console.log(msg)
  console.log(e)
}

export function isM3u8(url) {
  return /\.m3u8$/.test(url)
}

export function getVideoSourceOption(url) {
  let sourceObj = {}
  if (isM3u8(url)) {
    sourceObj = {
      type: 'application/x-mpegURL'
    }
  } else {
    sourceObj = {
      type: 'video/mp4'
    }
  }

  return Object.assign({}, sourceObj, {
    src: url
  })
}

export function debounce(func, wait, immediate) {

  var timeout;

  return function () {
    var context = this;
    var args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      // 如果已经执行过，不再执行
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait)
      if (callNow) func.apply(context, args)
    }
    else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait);
    }
  }
}

export function isAndroid() {
  let res;
  if (/(Android)/i.test(navigator.userAgent)) {
    // 安卓机
    res = true;
  } else {
    res = false
  }
  return res;
}

export function isPkgCode(code){
  return [8930003, 8930004, 8930005, 8930006, 8930007].includes(code)
}

// 判断设备类型
export function userAgentType (){
	var ua = navigator.userAgent,
	isWindowsPhone = /(?:Windows Phone)/.test(ua),
	isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
	isAndroid = /(?:Android)/.test(ua),
	isFireFox = /(?:Firefox)/.test(ua),
	isChrome = /(?:Chrome|CriOS)/.test(ua),
	isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
	isPhone = /(?:iPhone)/.test(ua) && !isTablet,
	isPc = !isPhone && !isAndroid && !isSymbian;
	return {
		isTablet: isTablet,
		isPhone: isPhone,
		isAndroid: isAndroid,
		isPc: isPc
	};
}

export function getRealCourseValue(value) {
  if (value.toString().indexOf('_') > -1) {
    return value.toString().substring(0, value.toString().indexOf('_'))
  } else {
    return value
  }
}

export function getIndex(value) {
  if (value.toString().indexOf('_') > -1) {
    let startIndex = value.toString().indexOf('_') + 1
    return value.toString().substring(startIndex, value.toString().length)
  } else {
    return -1
  }
}


export function getQuestionType(q_type, q_forms) {
  let typeStr = '';
  const language = sessionStorage.getItem("Select-language");
  const isEn = language === 'en';
  if (q_forms == 2) {
    if (q_type == 1) {
      typeStr = isEn ? "Multiple Choice Question" : "单选题";
    } else if (q_type == 2) {
      typeStr = isEn ? "Multiple Choice Question" : "多选题";
    } else if (q_type == 3) {
      typeStr = isEn ? "Fill-In-Blank Question" : "填空题";
    } else if (q_type == 4) {
      typeStr = isEn ? "Judgment Question" : "判断题";
    } else if (q_type == 5) {
      typeStr = isEn ? "Short Answer Question" : "问答题";
    } else if (q_type == 9) {
      typeStr = isEn ? "Puzzle Games" : "益智游戏";
    }
  } else {
    typeStr = isEn ? 'Subjective Question' : '主观题';
  }
  return typeStr;
}

export function setColor(id) {
  let sid = String(id);
  let num = sid.charAt(sid.length-1);
  return colorData[num];
}



// WEBPACK FOOTER //
// ./src/utils/index.js